import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/modal';
import {
  editProfileData,
  sendOTPMobile,
  updateMobile,
  verifyUserProfileOTP
} from '../../actions/personalInfo';
import { getFieldsFromDateAsFormat } from '../../../utils/dateFormatter';
import Loader from '../../../components/common/Loader';
import { getUaas } from '../../../refresh/selectors/featureFlagsSelector';
import { gtmEventPushAccountInteraction } from '../../../modules/ga/GTMdatalayer';
import { setErrorObject } from '../../../actions/shared/HTTPError';
import readAloudFormErrors from '../../../utils/accessibility';

class UpdateMobileNumPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
    // Using the same field name of mobileNumber so copying that to oldmobileNumber variable
    this.state = {
      initialProfData: {
        ...this.state.initialProfData,
        oldmobileNumber: this.state.mobileNumber,
        mobileNumber: '',
        otpValidMessage: ''
      }
    };
    this.state = {
      ...this.state,
      otpSentUser: false,
      otpSentMessage: '',
      otp: '',
      secondsRemaining: 60,
      enableResendOTP: false
    };
    this.local = {
      timeout: ''
    };
    this.updateMobileSubmit = this.updateMobileSubmit.bind(this);
    this.sendOTPbuttonClick = this.sendOTPbuttonClick.bind(this);
    this.modalRef = React.createRef();
  }

  focusInput = () => {
    if (this.modalRef.current) {
      this.modalRef.current.focus();
    }
  };

  _decrease(secLeft) {
    let timer = secLeft || this.state.secondsRemaining;
    if (timer > 0 && !this.state.errorMsg) {
      this.setState({ secondsRemaining: timer - 1 });
      this.local.timeout = setTimeout(this._decrease.bind(this), 1000);
    } else {
      this.local.timeout && clearTimeout(this.local.timeout);
      this.setState({ enableResendOTP: true });
    }
  }

  handleInputChange(newPartialInput) {
    this.props.setErrorObject({});
    this.setState(state => ({
      ...state,
      initialProfData: {
        ...state.initialProfData,
        ...newPartialInput,
        otpValidMessage: ''
      }
    }));
  }

  async updateMobileSubmit(event) {
    event.preventDefault();
    const { initialProfData: { mobileNumber = '' } = {} } = this.state;
    const formData = document.getElementById('updateMobileForm')
      ? document.getElementById('updateMobileForm').elements
      : [];
    let mobUpdateData = {};
    for (let idx = 0, len = formData.length; idx < len; idx++) {
      let { name = '', value = '', type = '' } = formData[idx] || {};
      if (type != 'button') {
        mobUpdateData[name] = value.trim();
      }
    }
    mobUpdateData.mobileNumber = mobileNumber;
    const updateMobileSuccessGA = () =>
      gtmEventPushAccountInteraction('my account screen', 'new mobile number', 'request success');
    if (mobUpdateData.otp) {
      const {
        isUaas = false,
        personalInfo: {
          profile: { uid = '' }
        }
      } = this.props;
      function isMobile() {
        let mobileDevice = false;
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        ) {
          mobileDevice = true;
        }
        return mobileDevice;
      }
      if (isUaas) {
        this.props.updateMobile(
          {
            oldMobileNumber: this.props.initialProfData.mobileNumber,
            newMobileNumber: mobUpdateData?.mobileNumber,
            otp: mobUpdateData?.otp
          },
          res => {
            if (res?.success) {
              localStorage.setItem('cancelUpdateMsg', 'Phone number update requested');
              localStorage.setItem('emailUpdateMsg', 'Phone number update requested');
              updateMobileSuccessGA();
              window.location = isMobile() ? '/my-account/' : '/my-account/orders';
            }
          }
        );
      } else {
        this.props.updateMobile(mobUpdateData, updateMobileSuccessGA);
      }
    } else {
      this.setState({ otpValidMessage: 'Please enter OTP' });
    }
    readAloudFormErrors('.error-msg');
  }

  resendOTP = () => {
    const {
      initialProfData: { mobileNumber = '', firstName = '', lastName = '' } = {}
    } = this.state;
    const otpSendData = {
      mobileNumber,
      firstName,
      lastName
    };
    this.props.sendOTPMobile(otpSendData, () => {
      let {
        personalInfo: { otpResponseObj = {}, otpSentSuccess = false }
      } = this.props;
      let { otpCodePresent = false, message = '' } = otpResponseObj;
      if (otpCodePresent && !message)
        this.setState({ otpSentUser: true, otpSentMessage: '', secondsRemaining: 60 }, () => {
          this._decrease();
        });
      else
        this.setState({
          otpSentUser: false,
          otpSentMessage: message || 'oops! something went wrong, please try again...'
        });
    });
  };

  sendOTPbuttonClick() {
    const formData = document.getElementById('updateMobileForm')
      ? document.getElementById('updateMobileForm').elements
      : [];
    let otpSendData = {};
    for (let idx = 0, len = formData.length; idx < len; idx++) {
      let { name = '', value = '', type = '' } = formData[idx] || {};
      if (
        (name === 'firstName' || name === 'mobileNumber' || name === 'lastName') &&
        type != 'button'
      ) {
        otpSendData[name] = value;
      }
    }
    let mobileNumber = otpSendData.mobileNumber ? otpSendData.mobileNumber : '';
    if (
      mobileNumber &&
      mobileNumber.length == 10 &&
      !isNaN(mobileNumber) &&
      !mobileNumber.startsWith('0')
    ) {
      const {
        isUaas = false,
        personalInfo: {
          profile: { uid = '' }
        }
      } = this.props;
      if (isUaas) {
        otpSendData = {
          mobileNumber,
          login: uid
        };
      }
      this.props.sendOTPMobile(otpSendData, () => {
        let {
          personalInfo: { otpResponseObj = {}, otpSentSuccess = false }
        } = this.props;
        let { otpCodePresent = false, message = '' } = otpResponseObj;
        // if (this?.props?.isUaas) {
        //     if (otpResponseObj) {
        //         this.setState({ otpSentUser: true, otpSentMessage: ''})
        //     } else {
        //         this.setState({ otpSentUser: false, otpSentMessage: message})
        //     }
        // }
        if (otpCodePresent && !message) this.setState({ otpSentUser: true, otpSentMessage: '' });
        else
          this.setState({
            otpSentUser: false,
            otpSentMessage: message || 'oops! something went wrong, please try again...'
          });
      });
    } else {
      this.setState({ otpSentMessage: 'Enter a valid phone number' });
    }
    this.focusInput();
    this._decrease();
  }

  showEnableRestorePhoneNumberNote = () => {
    const { profileChangeNewNumberNote = '' } = this.props;
    return (
      <div className="enable-restore-phone-number-note">
        <p>
          NOTE :<span className="note">{profileChangeNewNumberNote}</span>
        </p>
      </div>
    );
  };

  isMobile() {
    let mobileDevice = false;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      mobileDevice = true;
    }
    return mobileDevice;
  }

  render() {
    // Setting the Value from the Props
    const {
      initialProfData = {},
      modalName = '',
      otpSentUser = '',
      otpSentMessage = '',
      otpValidMessage = ''
    } = this.state;

    let {
      firstName = '',
      lastName = '',
      screenName = '',
      mobileNumber = '',
      dateOfBirth = '',
      otp = ''
    } = initialProfData;

    let { httpError: { error: { message = '' } = {} } = {}, enableRestorePhoneNumber } = this.props;
    const TEXT_MESSAGE = 'Valid for 10 mins';
    const RESEND_TEXT =
      this.state.secondsRemaining > 0
        ? `Resend OTP in <span>${this.state.secondsRemaining}s</span>`
        : 'Resend OTP';
    const CUSTOM_RESEND_CLASS = this.state.secondsRemaining === 0 ? 'reset-counter' : '';
    const CUSTOM_WIDTH_CLASS = this.state.secondsRemaining === 0 ? 'custom-wide' : '';
    // Date format change again
    var dateFields = getFieldsFromDateAsFormat(dateOfBirth);
    let { dd = '', mm = '', yyyy = '' } = dateFields;
    dateOfBirth = `${dd}/${mm}/${yyyy}`;

    return (
      <form className="update-mobile-form" id="updateMobileForm" onSubmit={this.updateMobileSubmit} tabIndex={-1}  ref={this.modalRef}>
        <Loader name="mobile-num-popup" />
        {!otpSentUser ? (
          <>
            <p className="update-mobile-no-text" role='heading' aria-level={2}>
              <strong>Enter New Phone Number</strong>
            </p>
            <div className="update-mob-input-field-block update-mob-oly">
              {enableRestorePhoneNumber && this.showEnableRestorePhoneNumberNote()}
            </div>
          </>
        ) : (
          <p className="update-mobile-no-text" role='heading' aria-level={2}>
            <strong>Enter OTP To Change Phone Number</strong>
          </p>
        )}
        <div className="update-mob-input-field-block update-mob-oly">
          <input type="hidden" name="firstName" value={firstName} />
          <input type="hidden" name="lastName" value={lastName} />
          <input type="hidden" name="screenName" value={screenName} />
          <input type="hidden" name="dateOfBirth" value={dateOfBirth} />

          {!otpSentUser ? (
            <>
              <div className="mobile-input-label">
                <input
                  className="update-mobile-mod-input"
                  value={mobileNumber}
                  onChange={e => this.handleInputChange({ mobileNumber: e.target.value })}
                  name="mobileNumber"
                  size="32"
                  maxLength="10"
                  type="tel"
                  aria-label="Enter New Phone Number"
                  autoComplete='tel'
                />
                <label htmlFor="mobileNumber">Enter New Phone Number</label>
              </div>
            </>
          ) : (
            ''
          )}

          {otpSentMessage ? (
            <div className="error-msg update-mobile-mod-reg-mes" aria-live="polite" role='alert' key={mobileNumber}>
              {otpSentMessage}
            </div>
          ) : (
            ''
          )}
          <div className="update-mobile-mod-type">
            {!this.props.mobileNumChangeLoader && !otpSentUser ? (
              <input
                type="button"
                className="update-mobile-mod-save otp-btn-new-mob-num"
                onClick={this.sendOTPbuttonClick}
                value={otpSentUser ? 'Resend OTP For Verification' : 'Send OTP For Verification'}
              />
            ) : (
              ''
            )}

            {otpSentUser ? (
              <div className="afterOtpSection">
                <div className="text-mob-update">
                  Enter OTP sent to the new phone number <span>+91 {mobileNumber}</span>
                </div>
                {enableRestorePhoneNumber && this.showEnableRestorePhoneNumberNote()}

                <div className="new-phone-otp">
                  <input
                    className="update-mobile-mod-otp-input"
                    value={otp}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*$/.test(val)) {   // Only allow numeric input
                        this.handleInputChange({ otp: val });
                      }
                    }}
                    name="otp"
                    size="32"
                    maxLength="6"
                    type="text"
                    aria-label="Enter OTP"
                  />
                  <label htmlFor="otp">Enter OTP</label>
                  {/* <div>
                                <span className={`${CUSTOM_ERROR_CLASS}`}>{ERROR_MESSAGE}</span>
                                <span dangerouslySetInnerHTML={ {__html: RESEND_LABEL} }  className={`${CUSTOM_RESEND}`} onClick={ ()=> props.resendOTP(USER_MOBILE_NUMBER, USER_EMAIL_ID) }/>
                            </div> */}
                </div>
                <div
                  className="container-message otp-msg-left"
                  style={this.isMobile() ? { marginTop: '5px' } : {}}
                >
                  {message ? (
                    <span
                      key={otp}
                      className="error-msg update-mobile-mod-reg-mes "
                      style={{ width: '70%', display: 'inline-block' }}
                      aria-live="polite"
                      role='alert'
                    >
                      {message}
                    </span>
                  ) : !message && otpValidMessage ? (
                    <span
                      key={otp}
                      className={`error-msg update-mobile-mod-reg-mes ${CUSTOM_WIDTH_CLASS}`}
                      aria-live="polite"
                      role='alert'
                    >
                      {otpValidMessage}
                    </span>
                  ) : (
                    <span className={`valid-for-min ${CUSTOM_WIDTH_CLASS}`}>{TEXT_MESSAGE}</span>
                  )}
                  <span
                    className={`resend-counter ${CUSTOM_RESEND_CLASS}`}
                    dangerouslySetInnerHTML={{ __html: RESEND_TEXT }}
                    onClick={this.resendOTP}
                    role="button"
                    tabIndex={0}
                    aria-disabled={this.state.secondsRemaining > 0}
                    disabled={this.state.secondsRemaining > 0}
                    aria-label={this.state.secondsRemaining > 0 ? 'Resend OTP not available for 60 seconds' : 'Resend OTP'}
                  />
                </div>

                <div className="mobaddaddr-type">
                  <input
                    type="submit"
                    className="update-mobile-mod-verify add-margin"
                    value="CONFIRM OTP"
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </form>
    );
  }
}

const mapStatetoProps = state => {
  const { personalInfo = [], httpError = {}, loaders = {} } = state;

  let mobileNumChangeLoader;

  if (loaders['mobile-num-popup']) {
    mobileNumChangeLoader = true;
  }

  return {
    personalInfo,
    httpError,
    mobileNumChangeLoader
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateMobile: (formData, callback) => {
      dispatch(updateMobile(formData, callback));
    },
    sendOTPMobile: (mobObj, callback) => {
      dispatch(sendOTPMobile(mobObj, callback));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    setErrorObject: error => {
      dispatch(setErrorObject(error));
    },
    verifyUserProfileOTP: (otp, mobileNumber) => {
      return dispatch(verifyUserProfileOTP(otp, mobileNumber, false, {}, true));
    }
  };
};

export default UpdateMobileNumPopup = connect(
  mapStatetoProps,
  mapDispatchToProps
)(UpdateMobileNumPopup);
